<div class="login-dialog">
  <div class="dialog-header">
    <h2>
      <mat-icon class="header-icon">card_membership</mat-icon>
      <span>Sign In to MemOwl License</span>
    </h2>
    <button mat-icon-button class="close-button" (click)="close()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="auth-content">
    <div id="firebaseui-auth-container" class="firebase-container"></div>
  </mat-dialog-content>
</div>

